import json from './json/tokens.json';

export const colors = json.color;
export const sizes = json.size;
export const effects = json.effect;
export const typography = json.typography;
